export const merchanTypes = [
	// 'CUSTOM',
	'SPONSOR',
	'OFFERING',
	'TESTIMONIAL',
	'CASHTRACK',
	'TRACK-AD',
];
